export class DecreaseHttpCallCount {
  static readonly type = '[UI] Decreasing HTTP Call Count';
}​
